import loadScript from './../util/loader';

const selectors = {
  popupContainer: '.pswp',
  popupCloseBtn: '.pswp__custom-close',
  popupIframe: 'iframe',
  popupCustomIframe: '.pswp__custom-iframe',
  popupThumbs: '.pswp__thumbs',
  dataOptionClasses: 'data-pswp-option-classes',
  dataVideoType: 'data-video-type',
  dataDisableSound: 'data-disable-sound',
  dataVideoId: 'data-video-id',
};

const classes = {
  classCurrent: 'is-current',
  classCustomLoader: 'pswp--custom-loader',
  classCustomOpen: 'pswp--custom-opening',
  classLoader: 'pswp__loader',
  loaded: 'loaded',
};

const loaderHTML = `<div class="${classes.classLoader}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;

const players = [];
const loadVideoYT = (playerId, videoId, disableSound) => {
  const defaultYoutubeOptions = {
    height: '720',
    width: '1280',
    events: {
      onReady: function (event) {
        const eventIframe = event.target.getIframe();

        eventIframe.setAttribute('tabindex', '-1');

        if (disableSound) {
          event.target.mute();
        } else {
          event.target.unMute();
        }
        event.target.playVideo();
      },
      onStateChange: function (event) {
        // Loop video if state is ended
        if (event.data == 0) {
          event.target.playVideo();
        }
        if (event.data == 1 && event.target.getIframe().parentElement) {
          // video is playing
          event.target.getIframe().parentElement.classList.add(classes.loaded);
        }
      },
    },
  };
  const currentYoutubeOptions = Object.assign({}, defaultYoutubeOptions);
  currentYoutubeOptions.videoId = videoId;
  if (videoId.length) {
    players[playerId] = new YT.Player(playerId, currentYoutubeOptions);
  }
};

const loadVideoVimeo = (videoId, state, disableSound) => {
  const oembed_url = 'https://vimeo.com/api/oembed.json';
  const vimeo_url = 'https://vimeo.com/' + videoId;
  let paramsString = '';

  const params = {
    url: vimeo_url,
    background: false,
    muted: disableSound,
    autoplay: true,
  };

  for (let key in params) {
    paramsString += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&';
  }

  fetch(`${oembed_url}?${paramsString}`)
    .then((response) => response.json())
    .then(function (data) {
      state.innerHTML = data.html;

      setTimeout(function () {
        state.parentElement.classList.add(classes.loaded);
      }, 1000);
    })
    .catch(function (error) {
      console.log('error: ', error);
    });
};

const openPhotoSwipe = (items, options = '') => {
  const pswpElement = document.querySelectorAll(selectors.popupContainer)[0];
  pswpElement.classList.add(classes.classCustomOpen);

  if (pswpElement.classList.contains(classes.classCustomLoader) && options !== '' && options.mainClass) {
    pswpElement.setAttribute(selectors.dataOptionClasses, options.mainClass);
    let loaderElem = document.createElement('div');
    loaderElem.innerHTML = loaderHTML;
    loaderElem = loaderElem.firstChild;
    pswpElement.appendChild(loaderElem);
  } else {
    pswpElement.setAttribute(selectors.dataOptionClasses, '');
  }

  const loadedPromise = loadScript({url: window.theme.assets.photoswipe});
  const returnPhotoSwipe = loadedPromise
    .then(() => {
      const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
      const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;
      const popupThumbsContainer = pswpElement.querySelector(selectors.popupThumbs);

      if (pswpElement.classList.contains(classes.classCustomLoader)) {
        pswpElement.classList.remove(classes.classCustomLoader);
      }

      pswpElement.classList.remove(classes.classCustomOpen);

      let newOptions = {
        history: false,
        focus: false,
        mainClass: '',
      };

      if (options !== '') {
        newOptions = options;
      }

      const popup = new PhotoSwipe(pswpElement, PhotoSwipeUI, items, newOptions);
      popup.init();

      const videoContainer = pswpElement.querySelector(selectors.popupCustomIframe);
      if (videoContainer) {
        const videoType = videoContainer.getAttribute(selectors.dataVideoType);
        const videoId = videoContainer.getAttribute(selectors.dataVideoId);
        const videoDisableSound = videoContainer.getAttribute(selectors.dataDisableSound) === 'true';
        const videoContainerId = videoContainer.id;

        if (videoType == 'youtube') {
          if (window.isYoutubeAPILoaded) {
            loadVideoYT(videoContainerId, videoId, videoDisableSound);
          } else {
            // Load Youtube API if not loaded yet
            window.loadYoutubeAPI();
            document.body.addEventListener('youtubeAPIReady', () => loadVideoYT(videoContainerId, videoId, videoDisableSound));
          }
        } else if (videoType == 'vimeo') {
          loadVideoVimeo(videoId, videoContainer, videoDisableSound);
        }
      }

      const closeBtn = pswpElement.querySelector(selectors.popupCloseBtn);
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          popup.close();
        });
      }

      popup.listen('close', function () {
        const popupIframe = pswpElement.querySelector(selectors.popupIframe);
        if (popupIframe) {
          popupIframe.setAttribute('src', '');
          popupIframe.parentNode.removeChild(popupIframe);
        }

        if (popupThumbsContainer && popupThumbsContainer.firstChild) {
          while (popupThumbsContainer.firstChild) {
            popupThumbsContainer.removeChild(popupThumbsContainer.firstChild);
          }
        }

        pswpElement.setAttribute(selectors.dataOptionClasses, '');
        const loaderElem = pswpElement.querySelector(`.${classes.classLoader}`);
        if (loaderElem) {
          pswpElement.removeChild(loaderElem);
        }
      });

      if (popupThumbsContainer && popupThumbsContainer.firstChild) {
        const stopDisabledScroll = (e) => {
          e.stopPropagation();
        };
        popupThumbsContainer.addEventListener('wheel', stopDisabledScroll);
        popupThumbsContainer.addEventListener('mousewheel', stopDisabledScroll);
        popupThumbsContainer.addEventListener('DOMMouseScroll', stopDisabledScroll);

        const popupThumbs = pswpElement.querySelectorAll(`${selectors.popupThumbs} > *`);
        popupThumbs.forEach((element, i) => {
          element.addEventListener('click', function (e) {
            e.preventDefault();
            this.parentElement.querySelector(`.${classes.classCurrent}`).classList.remove(classes.classCurrent);
            this.classList.add(classes.classCurrent);
            popup.goTo(i);
          });
        });

        const setCurrentThumb = () => {
          const lastCurrentThumb = pswpElement.querySelector(`${selectors.popupThumbs} > .${classes.classCurrent}`);
          if (lastCurrentThumb) {
            lastCurrentThumb.classList.remove(classes.classCurrent);
          }
          const currentThumb = popupThumbs[popup.getCurrentIndex()];
          const thumbsContainerLeft = popupThumbsContainer.scrollLeft;
          const thumbsContainerWidth = popupThumbsContainer.offsetWidth;
          const thumbsContainerPos = thumbsContainerLeft + thumbsContainerWidth;
          const currentThumbLeft = currentThumb.offsetLeft;
          const currentThumbWidth = currentThumb.offsetWidth;
          const currentThumbPos = currentThumbLeft + currentThumbWidth;

          currentThumb.classList.add(classes.classCurrent);

          if (thumbsContainerPos <= currentThumbPos || thumbsContainerPos > currentThumbLeft) {
            const currentThumbMarginLeft = parseInt(window.getComputedStyle(currentThumb).marginLeft);
            popupThumbsContainer.scrollTo({
              top: 0,
              left: currentThumbLeft - currentThumbMarginLeft,
              behavior: 'smooth',
            });
          }
        };

        popup.listen('imageLoadComplete', setCurrentThumb);
        popup.listen('beforeChange', setCurrentThumb);
      }
    })
    .catch((e) => console.error(e));
  return returnPhotoSwipe;
};

export default openPhotoSwipe;
